import PropTypes from 'prop-types';
import { JOIN_RULES, HISTORY_VISIBILITY } from '../../../../../constants/roomSettings';
import './SecurityPage.css';

const SecurityPage = ({
  joinRule = JOIN_RULES.INVITE,
  historyVisibility = HISTORY_VISIBILITY.JOINED,
  onJoinRuleChange = () => {},
  onHistoryVisibilityChange = () => {},
  canConfigure = false,
}) => {
  return (
    <div className="room-settings-page">
      <div className="room-settings-section">
        <h3 className="room-settings-section-title">Who can join</h3>
        <div className="room-settings-option-group">
          <label className="room-settings-option">
            <input
              type="radio"
              name="joinRule"
              value={JOIN_RULES.PUBLIC}
              checked={joinRule === JOIN_RULES.PUBLIC}
              onChange={(e) => onJoinRuleChange(e.target.value)}
              disabled={!canConfigure}
            />
            <div className="room-settings-option-content">
              <span className="room-settings-option-label">Anyone can join</span>
              <span className="room-settings-option-description">
                Anyone can find and join this room
              </span>
            </div>
          </label>

          <label className="room-settings-option">
            <input
              type="radio"
              name="joinRule"
              value={JOIN_RULES.INVITE}
              checked={joinRule === JOIN_RULES.INVITE}
              onChange={(e) => onJoinRuleChange(e.target.value)}
              disabled={!canConfigure}
            />
            <div className="room-settings-option-content">
              <span className="room-settings-option-label">Invited users only</span>
              <span className="room-settings-option-description">
                Only users who receive an invitation can join
              </span>
            </div>
          </label>
        </div>
      </div>

      <div className="room-settings-section">
        <h3 className="room-settings-section-title">Visibility of chat history</h3>
        <div className="room-settings-option-group">
          <label className="room-settings-option">
            <input
              type="radio"
              name="historyVisibility"
              value={HISTORY_VISIBILITY.INVITED}
              checked={historyVisibility === HISTORY_VISIBILITY.INVITED}
              onChange={(e) => onHistoryVisibilityChange(e.target.value)}
              disabled={!canConfigure}
            />
            <div className="room-settings-option-content">
              <span className="room-settings-option-label">From invitation</span>
              <span className="room-settings-option-description">
                Members can see history from when they were invited
              </span>
            </div>
          </label>

          <label className="room-settings-option">
            <input
              type="radio"
              name="historyVisibility"
              value={HISTORY_VISIBILITY.JOINED}
              checked={historyVisibility === HISTORY_VISIBILITY.JOINED}
              onChange={(e) => onHistoryVisibilityChange(e.target.value)}
              disabled={!canConfigure}
            />
            <div className="room-settings-option-content">
              <span className="room-settings-option-label">From joining</span>
              <span className="room-settings-option-description">
                Members can see history from when they joined
              </span>
            </div>
          </label>

          <label className="room-settings-option">
            <input
              type="radio"
              name="historyVisibility"
              value={HISTORY_VISIBILITY.SHARED}
              checked={historyVisibility === HISTORY_VISIBILITY.SHARED}
              onChange={(e) => onHistoryVisibilityChange(e.target.value)}
              disabled={!canConfigure}
            />
            <div className="room-settings-option-content">
              <span className="room-settings-option-label">Visible for all participants</span>
              <span className="room-settings-option-description">
                All members can see complete history
              </span>
            </div>
          </label>

          <label className="room-settings-option">
            <input
              type="radio"
              name="historyVisibility"
              value={HISTORY_VISIBILITY.WORLD_READABLE}
              checked={historyVisibility === HISTORY_VISIBILITY.WORLD_READABLE}
              onChange={(e) => onHistoryVisibilityChange(e.target.value)}
              disabled={!canConfigure}
            />
            <div className="room-settings-option-content">
              <span className="room-settings-option-label">Visible for everyone</span>
              <span className="room-settings-option-description">
                Anyone can read the chat history without joining
              </span>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};

SecurityPage.propTypes = {
  joinRule: PropTypes.string,
  historyVisibility: PropTypes.string,
  onJoinRuleChange: PropTypes.func,
  onHistoryVisibilityChange: PropTypes.func,
  canConfigure: PropTypes.bool,
};

export default SecurityPage;
